import {
  YES
} from '../../../lib/GenericTools.lib';
import {
  joinClassName
} from '../Libraries/Theme.lib';
import Box from './Box';
import Typography from './Typography';

export default function TaggedValue({ tag, value, className = '' }) {
  return YES(value) && (
    <Box row flex1
      className={joinClassName([
        'flex-align-left-top',
        className
      ])}
    >
      <Typography
        className='mr-1 fw-500 f-sm'
      >
        {tag}:
      </Typography>
      <Typography className='fw-400 f-sm flex-1'>
        {value}
      </Typography>
    </Box>
  )
}
